import { Checkbox } from 'semantic-ui-react';
import React, { Component } from 'react';
import { Loader, Dimmer, Button } from 'semantic-ui-react';

class CheckboxList extends Component {
  constructor(props) {
    super(props);
    if (window[props.role] == null) window[props.role] = [];
    this.state = {
      checkedState: {}
    };
  }
  
  handleCheckboxChange = (item_label, checked) => {
    if (checked === true && window[this.props.role].indexOf(item_label) === -1)
    window[this.props.role].push(item_label);
  else
    window[this.props.role] = window[this.props.role].filter(item => item !== item_label);
  
    this.setState(prevState => ({
      checkedState: {
        ...prevState.checkedState,
        [item_label]: checked
      }
    }));
    this.props.setChartLoading(true);
    if (typeof gtag === "function")
      gtag('event', item_label, { 'event_category': 'NGSpice', 'event_label': this.props.role });
  };

  getSelectedCheckboxes = () => {
    const selected = {};
    for (const key in this.state.checkedState) {
      if (this.state.checkedState[key] === true) {
        selected[key] = this.state.checkedState[key];
      }
    }
    return selected;
  };

  componentDidMount() {
    this.updateSelectedNodes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.checkedState !== this.state.checkedState) {
      this.updateSelectedNodes();
    }
  }

  updateSelectedNodes = () => {
    const { initialSelectedLabels, setSelectedNodes, role } = this.props;
    if (initialSelectedLabels == null) return;

    const labels = [1, 2, 3];
    let datasets = [];
    
    let selected = [];
    
    for (const key in window[this.props.role]) 
    if (selected.indexOf(window[this.props.role][key]) === -1)
    {      
      
        selected.push(window[this.props.role][key]);
        datasets.push({
          label: window[this.props.role][key],
          data: [],
          borderColor: 'rgb(255, 99, 132)',
          backgroundColor: 'rgba(255, 99, 132, 0.5)',
        });      
    }
    
    setSelectedNodes({
      labels,
      datasets
    });        
    com.clientside.main.Html5Bootstrap.jsCall("setSelectedNodesNums", selected, role);
    this.onSimulate();
  };

  onSimulate = () => {
    com.clientside.main.Html5Bootstrap.jsCall("simulate");
  };

  onRefresh = () => {
    com.clientside.main.Html5Bootstrap.jsCall("refresh");
  };

  render() {
    const { top, label, role, nodes, isChartLoading } = this.props;
    const { checkedState } = this.state;

    return (
      <>
        {isChartLoading ? (
          <div style={{ padding: 8 }}>{l.loading} ...</div>
        ) : (
          <>
            <p style={{ marginTop: top, textAlign: 'center', color: '#000000', paddingBottom: 0, paddingTop: 0 }}>
              {label}
            </p>

            {nodes.map((item, index) => {
              if (item.role !== role) {
                return null;
              }

              return (
                <div key={index}>
                  <Checkbox
                    key={item.label}
                    label={
                      <label style={{ fontFamily: 'monospace', color: item.css_color }}>
                        {window.thumbs.getDataLabel(item.label, role, item.metric_type)}
                      </label>
                    }
                    checked={window[role].indexOf(item.label) > -1}
                    onChange={(e, data) => this.handleCheckboxChange(item.label, data.checked)}
                  />
                </div>
              );
            })}
          </>
        )}
      </>
    );
  }
}

export default CheckboxList;
